import type { ComponentProps } from 'react';

import { Input } from '@nucleus-commerce/ui/components/input';
import { cn } from '@nucleus-commerce/ui/lib/utils';

import type { CodeMethod } from '../schemas/two-factor-rules';

export type OneTimeCodeInputProps = Omit<ComponentProps<typeof Input>, 'type'> & {
  method?: CodeMethod;
};

/** Text input tuned for a 6-digit authenticator code or a recovery code. */
export function OneTimeCodeInput({ method = 'totp', className, ...props }: OneTimeCodeInputProps) {
  const totp = method === 'totp';
  return (
    <Input
      type="text"
      inputMode={totp ? 'numeric' : 'text'}
      autoComplete={totp ? 'one-time-code' : 'off'}
      autoCapitalize="off"
      spellCheck={false}
      maxLength={totp ? 7 : 12}
      placeholder={totp ? '123 456' : 'ab2c-d3ef'}
      className={cn('h-11 font-mono tracking-widest', className)}
      {...props}
    />
  );
}
